export const getQueryParam = (key: string) => {
  const url = new URL(globalThis.window.location.href);
  return url.searchParams.get(key);
};
